import React from 'react'

import { useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';


import axios from 'axios'
import config from '../../config/config'

const guidelines = [
    {
        title: "Be Factual",
        description: "Read the instructions provided along with the questions carefully and try to include the facts to the best of your knowledge."
    },
    {
        title: "Be Decent",
        description: "Talking about your alma mater should always have decency, even when criticising it. No rash words should be used in the content. This may lead to the approval being rejected."
    },
    {
        title: "Be Original",
        description: "Write your own experience. Don't Copy. Most elaborate reviews might bring extra rewards. Write your review on your own, don't let anyone else use your identity."
    },
    {
        title: "Be Patient",
        description: "The review has 8 steps, each step covering one aspect of your college life. So, answer them with patience so they add value to the reader. You can always complete the review form in phases."
    },
    {
        title: "Be Social",
        description: "Once you are done with your review, share the review form with as many students as possible. More reviews mean more rewards."
    }
];


const rules = [
    "Monthly Winners will be announced at the start of each month.",
    "Top 3 monthly winners will each receive a bonus cash reward of ₹1,00,000, ₹50,000, ₹30,000 respectively. Candidates in positions 4th - 10th, 11th - 20th and 21st - 25th on the leaderboard at the end of the month will get a ₹10,000, ₹500 and ₹300 respectively bonus cash prize. This is separate from the amount earned through individual referrals.",
    "To be eligible for the bonus cash reward, the 1st prize winner should have at least 150 successful referrals; the 2nd prize winner should have at least 120 successful referrals; the 3rd prize winner should have at least 100 successful referrals; 4th–10th position holders must have at least 50 referrals, 11th-20th position must have at least 30 referrals and the remaining 21st-25th must have 15 referrals each.",
    "There are two ways to earn reward points: Write a college review to get up to 1000 points (₹500). Minimum of 20 points (₹10).",
    "Share your referral code with your friends to encourage them to write college reviews. Upon approval of such reviews, you will earn up to 200 points(₹100) to Minimum 10 points (₹5). When the review submitted using your referral code is approved, you will be rewarded in cash.",
    "For each successfully approved review for selected colleges obtained through a referral, the user getting the referral will get assured 200 points (₹100).",
    "A successful referral is when the review submitted using your referral code is approved. 1 point = ₹0.5",
    "If Collegedunia has collected more than 20 reviews in a month for a specific college, the referral reward and review writing reward will be downgraded to 20 points for referral and 40 points for writing a review."
];

const Reviewcomp = () => {




    // search bar jsx 


    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [filteredResults, setFilteredResults] = useState([]);
    const [selectedIndex] = useState(-1);
    const searchRef = useRef(null);



    // Handle input change
    const handleInputChange = async (e) => {
        const value = e.target.value;
        setQuery(value);

        if (value.length > 1) {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/search_api`, {
                    params: {
                        courseName: value,
                        collegeName: value,
                        state: value,
                    },
                });
                setSuggestions(response.data.searchAPIData);
            } catch (err) {
                console.error("Search error:", err);
            }
        } else {
            setSuggestions([]);
        }
    };

    // Handle selection on click
    const handleSelect = async (item) => {
        if (item.collegeName) {
            const collegeSlug = item.collegeName.toLowerCase().replace(/\s+/g, "-");
            const navigatePath = `/college/${collegeSlug}`;
            navigate(navigatePath);

            navigate(navigatePath);
        } else {
            alert("No college name found.");
        }

        setQuery("");
        setSuggestions([]);
        setFilteredResults([]);
    };


    // for validation 
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        review: '',
        // city: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        email: '',
        // city: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate before submission
        const newErrors = {};
        if (!formData.name || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            newErrors.name = "Please enter a valid name";
        }
        // if (!formData.phone || !/^\d{10}$/.test(formData.phone)) {
        //     newErrors.phone = "Please enter a valid 10-digit phone number";
        // }
        // if (!formData.city || !/^[a-zA-Z\s]+$/.test(formData.city)) {
        //     newErrors.city = "Please enter a valid city";
        // }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            console.log(newErrors, "newErrors");
            return; // Stop submission
        }

        const email = formData.email;
        const review = formData.review;
        const terms = e.target.terms.checked;

        const dataToSend = {
            ...formData,
            email,
            review,
            terms,
        };

        try {
            const response = await axios.post(
                `${config.API_BASE_URL}/api/user/review_data`,
                dataToSend,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 201 || response.status === 200) {
                alert("Form submitted successfully!");
                setFormData({ name: '', email: '', review: '' });
            } else {
                alert("Submission failed: " + response.data.message);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Error submitting form.");
        }
    };




    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'name') {
            if (/^[a-zA-Z\s]*$/.test(value)) {
                setFormData({ ...formData, [name]: value });
                setErrors({ ...errors, [name]: '' });
            } else {
                setErrors({ ...errors, [name]: 'You can type only characters' });
            }
        // } else if (name === 'phone') {
        //     if (/^\d{0,10}$/.test(value)) {
        //         setFormData({ ...formData, phone: value });
        //         setErrors({ ...errors, phone: '' });
        //     } else {
        //         setErrors({ ...errors, phone: 'Only numbers are allowed' });
        //     }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };



    return (
        <div>
            <div className="container-fluid mb-5 pb-5 ">
                <div className="row mt-0 pt-0">
                    <div className="col m-0 p-0">
                        <div className="mybackground mt-0 pt-0">
                            <form class="nosubmitcls form-inline searchbar formcls mt-0 pt-0">
                                {/* slider text here  */}
                                <div className="mt-3 reviw_contenttext">
                                    <p className='guest_text' >Hello Guest</p>
                                    <span className='guest_span'>Write a Review, Refer and Win Up To </span>
                                    <h3 className='review_num'>₹100000*</h3>
                                    <h5 className='review_para'>Earn up to ₹200 ( 400 points) for approved reviews. Earn ₹20 (40 points) per referral. Receive ₹500 (1000 points) for writing & ₹100 (200 points) for every referred review from the selected colleges.</h5>

                                    {/* Search bar here */}


                                    {/* Search Bar */}
                                    <div className="input-group mt-4 position-relative">
                                        <input
                                            type="text"
                                            className="nosubmitcls bg-light p-4 form-control"
                                            placeholder="Search for colleges, Stream, courses, City and more."
                                            aria-label="Username"
                                            aria-describedby="basic-addon1"
                                            value={query}
                                            onChange={handleInputChange}
                                        />
                                        <div className="input-group-append">
                                            <button className="searchbtn mybtn" type="button">Search</button>
                                        </div>

                                        {/* Suggestions Dropdown */}
                                        {/* Suggestions Dropdown */}
                                        {suggestions.length > 0 && (
                                            <ul className="suggestion-dropdown list-group position-absolute w-100 mt-1 zindex-dropdown">
                                                {suggestions.map((item, idx) => (
                                                    <li key={idx} className="list-group-item list-group-item-action">
                                                        <Link
                                                            to={`/college/${item._id}`}
                                                            className="text-decoration-none text-dark"
                                                        >
                                                            <strong>{item.collegeName}</strong> – {item.state} – {item.city}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                    {/* Filtered Results */}
                                    <div className="mt-3" ref={searchRef}>
                                        {filteredResults.length > 0 && (
                                            <ul className="list-group w-50 mx-auto">
                                                {filteredResults.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        className={`list-group-item ${selectedIndex === index ? "active" : ""}`}
                                                        onClick={() => handleSelect(item)}
                                                    >
                                                        {item.name} <span className="text-muted">({item.type})</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container'>
                <h3 className='fw-bold fs-2'>Do's & Dont's - Points to Consider While Writing a Review</h3>
                <ul>
                    {guidelines.map((item, index) => (
                        <li key={index} className='mt-3'>
                            <strong>{item.title} - </strong>{item.description}
                        </li>
                    ))}
                </ul>


                <h3 className='fw-bold mt-5'>Rules</h3>
                <ul>
                    {rules.map((rule, index) => (
                        <li key={index} className='mt-3'>{rule}</li>
                    ))}
                </ul>
            </div>



            {/* Review form here  */}

            <div className="container mt-5 ">
                <h3 className='fw-bold text-center fs-2'>Write a Review</h3>
                <div className="">
                    <div className="">
                        <div className='text_cont'>

                        </div>

                        <form className="form" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="input-field">
                                    <input
                                        required
                                        autoComplete="off"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="name">Full Name</label>
                                    {errors.name && <span className="text-danger">{errors.name}</span>}
                                </div>

                                <div className="input-field">
                                    <input
                                        required
                                        autoComplete="off"
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="email">Email</label>
                                </div>
                            </div>


                            <div className="input-field">
                                <textarea
                                    required
                                    name="review"
                                    id="review"
                                    rows="4"
                                    placeholder="Write your review here..."
                                    onChange={handleChange}
                                    value={formData.review || ''}
                                ></textarea>
                            </div>


                            <div className="d-flex align-items-start">
                                <input type="checkbox" name="terms" id="termsCheckbox" className="me-2 mt-1" />
                                <label htmlFor="termsCheckbox" className="heading2 mb-0">
                                    By submitting this form, you accept and agree to our <a href="/terms&condition">Terms of Use</a>.
                                </label>
                            </div>

                            <div className="formbtn">
                                <button type="submit" className="mybtn float-right">Submit</button>
                            </div>
                        </form>


                    </div>
                </div>
            </div>




        </div>
    )
}

export default Reviewcomp
